// @flow
import { BooleanSelectField } from '@src/formik-utils/FormFields';
import useIsAdmin from '@streaming-projects/useIsAdmin';
import React from 'react';
import { CNBC_CONFIG } from '@streaming-projects/default-commit-details/config';

export const SPDefaultCommitCreditsAndBurstsEnabledContainer = () => {
  const isUserAdmin = useIsAdmin();
  const { displayName, backendFieldName } = CNBC_CONFIG;

  return (
    <BooleanSelectField
      disabled={!isUserAdmin}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
    />
  );
};
